import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionEmpresa(obj) {
    try {
        let data = { error: true };
        const { code } = await fetch(
            API_BASE_URL + "/configuracion-empresa/create-configuracion-empresa",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionEmpresa err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/configuracion-empresa/obtener-configuracion-empresa",
            API_BASE_URL + "/configuracion-empresa/obtener-configuracion-empresa",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/configuracion-empresa/actualizar-configuracion-empresa",
            API_BASE_URL + "/configuracion-empresa/actualizar-configuracion-empresa",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}
